import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import Guide from './pages/Guide';
import Community from './pages/Community';
import Leaderboard from './pages/Leaderboard';
import Download from './pages/Download';
import Donate from './pages/Donate';
import BlogDetail from "./pages/BlogDetail";
import EventCashcoin from "./pages/EventCashcoin";
import InformationGuide from "./pages/Information";
import CombineInfo from "./pages/CombineInfo";
import AllNews from "./pages/AllNews";
import PitbossTracker from "./pages/PitbossTracker";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <main className="flex-grow pt-0"> {/* biar navbar fixed nggak nabrak */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/community" element={<Community />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/rangking" element={<Leaderboard />} />
            <Route path="/download" element={<Download />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/event-cash-coin" element={<EventCashcoin />} />
            <Route path="/news" element={<AllNews />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/information" element={<InformationGuide />} />
            <Route path="/combine-info" element={<CombineInfo />} />
            <Route path="/pitboss-tracker" element={<PitbossTracker />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
